import { useQuery } from '@tanstack/react-query';
import { getCookie } from 'cookies-next/client';

import { LANGUAGE_KEY } from '@/constants/cookies.ts';
import { X_COUNTRY_CODE, X_REGION_CODE } from '@/constants/headers';
import { PRODUCT_EXTENDED_BY_SLUG } from '@/modules/ReactQuery/cacheKeys.ts';
import { getProductBySlugExtended } from '@/modules/product/api.ts';

export function useProductBySlugExtended(
  slug: string,
  headers?: Record<string, string>
) {
  return useQuery({
    queryKey: [
      PRODUCT_EXTENDED_BY_SLUG,
      slug,
      headers?.[X_COUNTRY_CODE],
      headers?.[X_REGION_CODE],
    ],
    queryFn: async () => {
      const res = await getProductBySlugExtended({
        slug,
        lang: getCookie(LANGUAGE_KEY) || 'en',
        headers,
      });
      return res.data;
    },
    enabled: !!slug,
  });
}
